import React from 'react'

import LetterLandingCTO from '../LetterLandingCTO';

import logo_target from '../../../images/letterfunnel/xlinq.webp';
import screenshot_target from '../../../images/letterfunnel/santiagoaragon.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLandingCTO
      fullname="Santiago Aragón"
      firstname="Santiago"
      companyname="XLINQ"
      competition="OutSystems en Mendix"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/santiagoaragon.js